export const UI_COPIES = {
  defaultWelcome: 'Welcome, and enjoy your visit!',
};

// @ts-ignore
export const isDev = import.meta.env.MODE === 'development';

export function getServerEndpoint() {
  if (isDev) {
    return 'http://localhost:1337';
  }

  if (typeof window !== 'undefined') {
    return window.location.origin;
  }

  return '';
}

export const SERVER_ENDPOINT = getServerEndpoint();

// Get configuration from server via __INITIAL_DATA__
// @ts-ignore
const initialData = typeof window !== 'undefined' ? window.__INITIAL_DATA__ : {};

// Frontend configuration constants
// NAME_WAITING_TIME: How long to display each name in the badge rotation (milliseconds)
// Sourced from backend env (NAME_WAITING_TIME in Akeyless), falls back to 10 seconds
export const NAME_WAITING_TIME = initialData?.config?.nameWaitingTime || 10000;

// Maximum font size for dynamic text scaling
// Sourced from backend env (MAX_FONT_SIZE in Akeyless), falls back to 200
export const MAX_FONT_SIZE = initialData?.config?.maxFontSize || 200;

